import { Component } from '@angular/core';

@Component({
  selector: 'readyz',
  templateUrl: './readyz.component.html',
  standalone: true,
})
export class ReadyzComponent {}
